import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DrivertraceService, Result, VehiclePositionAndDrivers } from '../../../services/drivertrace/drivertrace.service';
import { AuthService } from '../../../services/auth/auth.service';
import moment, { getCurrentTimezone } from './../../../moment.override';
import { interval, Subscription } from 'rxjs';
import { DriversService, DriverWithStatistics } from '../../../services/drivers/drivers.service';
import { PROFILE } from '../../../helpers/globals';
import { ProgressBarService } from 'app/services/progress-bar/progress-bar.service';
import { finalize } from 'rxjs/operators';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';
import type {
    ActivityChartData,
    ChartHighlight,
    ChartMarker,
    ChartVisibility,
} from 'tacho-activity-chart';
import type { DriverDiagramDayLike } from '../../../components/tacho-activity-chart/driver-chart-data';
import { buildDriverChartData } from '../../../components/tacho-activity-chart/driver-chart-data';
import { filterDiagramDays, padDiagramPeriod } from '../../../components/tacho-activity-chart/diagram-period';
import { MatTableDataSource } from '@angular/material/table';
import { ProService } from 'app/services/pro/pro.service';
import { error } from 'console';
import { MessageService } from 'primeng/api';
import { NameFormatService } from 'app/services/name-format/name-format.service';
import { egretAnimations } from '../../../helpers/egret-animations';
// @ts-ignore
// import * as L from 'leaflet';

type Group = {
    name: string;
    terminalMac: string;
    group: boolean;
    vin?: string;
    /** TA - tachograph available */
    ta?: boolean;
    /** CI - card inserted */
    ci?: boolean;
    /** CD - card download */
    cd?: boolean;
}






@Component({
    selector: 'app-drivertrace',
    templateUrl: './drivertrace.component.html',
    styleUrls: ['./drivertrace.component.css'],
    animations: [
        ...egretAnimations,
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ]
})
export class DrivertraceComponent implements OnInit, OnDestroy, AfterViewInit {

    @Input() availableDrivers = [] as DriverWithStatistics[];

    @ViewChild('vehicleMap') vehicleMap: any;

    private _subscriptions: Subscription;

    filterValue = '';
    driversNames = [];
    driversCardNumber = [];

    sortload = true;
    traceResponseArray = [] as Result[];
    dataSource = new MatTableDataSource<Result>([]);
    groupedDataSource = new MatTableDataSource<Result | Group>([]);

    profile = PROFILE;
    dataexists = false;
    displayedColumn = ['state', 'driver', 'drive', 'drive24', 'drivedriver', 'drivecodriver', 'work', 'dailyWork', 'weeklyWork', 'nextrest', 'nextwork'];
    displayedColumn2 = ['state', 'driver', 'drive', 'drive24', 'drivedriver', 'drivecodriver', 'nextbreak', 'nextrest', 'nextdrive'];
    expandedElement: Result | null;

    chartDataByDriverId: Record<number, ActivityChartData> = {};
    vehicleChartDataByDriverId: Record<number, ActivityChartData> = {};
    chartVisibility: Partial<ChartVisibility> = {};
    chartTimezone = '';
    chartLocale = 'en-GB';
    selectedCompanyId = localStorage.getItem('selectedCompanyId');
    displayedColumns = ['name', 'cardInformation', 'lastActivity', 'validThrough'];

    now = this.nowFormatDateWithoutYear(new Date());

    dateChange = this.nowFormatDateWithoutYear(new Date()).toString();
    periodStart: number;
    periodEnd: number;
    diagrammLoaded = false;
    noDataText = false;

    /*
        if true -> ascendent else if false -> descendent
     */
    sortByStatusFlag = true;
    sortByDriverFlag = true;
    companyId: number;
    startOfWeek: any;

    queryRunning = false;
    allowBanner = false;

    pro$ = this.proService.pro$;
    clientIsPro: boolean = false;

    private updateSubscription: Subscription;

    private companySpecificSubscription: Subscription;

    /**
     * Colour of the Vehicles tab status circle, driven by the flags of readTachographParameters:
     * TA - tachograph available, CI - card inserted, CD - card download.
     *
     * green  - tachograph available, card inserted and card downloaded
     * orange - tachograph available, but the card is not inserted or not downloaded
     * red    - tachograph not available, the card flags do not matter
     */
    getTerminalStatusColor(row: Group | Result | undefined | null): string {
        const vehicle = row as Group | undefined | null;
        if (!vehicle?.ta) {
            return 'red-500';
        }
        return vehicle.ci && vehicle.cd ? 'green-500' : 'orange-500';
    }

    /** Tooltip of the status circle: the state of the three flags. */
    getTerminalStatusTooltip(row: Group | Result | undefined | null): string {
        const vehicle = row as Group | undefined | null;
        const yes = this._translate.instant('Yes');
        const no = this._translate.instant('No');
        const flag = (value: boolean | undefined) => value ? yes : no;
        return `TA: ${flag(vehicle?.ta)} | CI: ${flag(vehicle?.ci)} | CD: ${flag(vehicle?.cd)}`;
    }

    static formatDate(ts) {
        if (ts === 0 || ts === '') {
            return '--/--/---- --:--';
        } else {
            return moment(ts * 1000).myFormat('LL dddd HH:mm');
        }
    }
    vehiclePositionAndDrivers: VehiclePositionAndDrivers[] = []

    featureEnabled = false
    // the Vehicles tab is for reseller users (ClientIsReseller from auth/asr)
    vehiclesTabEnabled = false;

    constructor(private driverstraceService: DrivertraceService,
        private readonly proService: ProService,
        private progressBarService: ProgressBarService,
        private _authService: AuthService,
        private _translate: TranslateService,
        private readonly messageService: MessageService,
        private _driverService: DriversService,
        private nameFormatService: NameFormatService) {
        this._subscriptions = new Subscription();
        this.companySpecificSubscription = new Subscription();
    }
    ngAfterViewInit(): void {
    }

    onTabChange(event: any) {
        if (this.vehicleMap) {
            this.vehicleMap.onTabVisible();
        }
    }

    ngOnInit() {
        this.startOfWeek = this.getMonday(new Date());
        // console.log(this.startOfWeek);

        this.featureEnabled = this._authService.getLoggedInUser().clientId === 21;
        // before the company subscription below, so the first data load already knows about the Vehicles tab
        this._subscriptions.add(this._authService.currentUserRoles$.subscribe(roles => {
            this.vehiclesTabEnabled = !!roles?.ClientIsReseller;
        }));

        this.progressBarService.mode.next('query');
        const subscription = this._authService.currentCompanyId.subscribe((newCompanyId) => {
            this.proService.pro$.subscribe((pro) => {
                if (pro.pro === 'REQUESTED' || pro.pro === 'TRIAL' || pro.pro === 'TRIAL_PRO') {
                    this.clientIsPro = true;
                } else {
                    this.clientIsPro = false;
                }
            })
            this.companySpecificSubscription.unsubscribe();
            if (newCompanyId !== 0) {
                this.companyId = newCompanyId;
                this.dataexists = false;
                this.traceResponseArray = [];

                this.makeDataForDrivers();
                // this.autoRefresh(newCompanyId);
                this.searchDrivers(newCompanyId);
            }
        });
        this._subscriptions.add(subscription);

    }

    driversGroupedByVehicle(data: Result[]) {
        const groupedData: (Result | Group)[] = [];
        const vehicleMap = new Map<string, Result[]>();
        const getGroupKey = (terminalMac: string, vin: string): string => terminalMac || vin || '';

        data.forEach(item => {
            const vehicleKey = getGroupKey(item.terminalMac || '', item.vehicleIdentificationNumber);
            if (!vehicleKey) {
                groupedData.push(item);
                return;
            }
            if (!vehicleMap.has(vehicleKey)) {
                vehicleMap.set(vehicleKey, []);
            }
            vehicleMap.get(vehicleKey).push(item);
        });

        //add missing vehicles (terminals with no driver data)
        this.vehiclePositionAndDrivers.forEach(vehicle => {
            const vehicleKey = getGroupKey(vehicle.terminalMac || '', vehicle.vin);
            if (vehicleKey && !vehicleMap.has(vehicleKey)) {
                vehicleMap.set(vehicleKey, []);
            }
        });

        vehicleMap.forEach((drivers, vehicleKey) => {
            drivers = drivers
                .filter(driver => this.hasVehicleSlotData(driver))
                .sort((a, b) => a.slot - b.slot);

            const vehiclesInGroup = this.vehiclePositionAndDrivers
                .filter(vehicle => getGroupKey(vehicle.terminalMac || '', vehicle.vin) === vehicleKey);
            const firstVehicle = vehiclesInGroup[0];
            const vinsInGroup = [...new Set(
                [...vehiclesInGroup.map(vehicle => vehicle.vin), ...drivers.map(driver => driver.vehicleIdentificationNumber)]
                    .filter(vin => !!vin)
            )];
            const terminalMac = firstVehicle?.terminalMac || drivers[0]?.terminalMac || '';

            groupedData.push({
                name: (firstVehicle?.registrationNumber || vinsInGroup[0] || vehicleKey || '-'),
                terminalMac: terminalMac,
                group: true,
                ta: firstVehicle?.ta,
                ci: firstVehicle?.ci,
                cd: firstVehicle?.cd,
                vin: vinsInGroup.join(', ')
            } as Group);
            drivers.forEach(driver => {
                groupedData.push(driver);
            });
        });
        this.groupedDataSource.data = groupedData;
    }

    private hasVehicleSlotData(driver: Result): boolean {
        return !!(driver?.driverInfo?.name || driver?.driverInfo?.cardNumber);
    }

    /**
     * Strips the leading 3 characters (mostly the country code) and the last 2 characters,
     * e.g. "RO 000000000IRWD000" -> "000000000IRWD0".
     */
    private trimCardNumber(cardNumber: string): string {
        if (!cardNumber) {
            return cardNumber;
        }
        return cardNumber.length > 5 ? cardNumber.substring(3, cardNumber.length - 2) : cardNumber;
    }

    /**
     * @param trimCardNumber only the Vehicles tab sends the card number without the country code
     * (first 3 characters) and without the last 2 characters. The Drivers tab sends it as is.
     */
    onClickRefreshDataWithoutRDUAdmin(item: Result, event: Event, trimCardNumber = false) {
        event.stopPropagation();
        if (!item.driverInfo.cardInserted) {
            return;
        }
        type extendedItem = typeof item & { remainingSeconds: number | null };
        const obj = item as extendedItem;
        const cardNumber = trimCardNumber ? this.trimCardNumber(obj.driverInfo.cardNumber) : obj.driverInfo.cardNumber;
        this.driverstraceService.refreshDataWithoutRDUAdmin(this.companyId, cardNumber).subscribe(
            response => {
                this.messageService.add({
                    severity: 'success',
                    detail: this._translate.instant("The will be refreshed in 10 minutes"),
                    summary: this._translate.instant('success'),
                    life: 10 * 1000
                })
                obj.remainingSeconds = 600;
                const intervalId = setInterval(() => {
                    obj.remainingSeconds -= 5;
                    if (obj.remainingSeconds <= 0) {
                        clearInterval(intervalId);
                        obj.remainingSeconds = null;
                        // refresh the data
                        this.getDataForDrivers(this.companyId);
                    }
                }, 5 * 1000);

            },
            error => {
                this.messageService.add({
                    severity: 'error',
                    detail: this._translate.instant(error.error.message),
                    summary: this._translate.instant('error'),
                    life: 10 * 1000
                })
            }
        )
    }

    getMonday(d) {
        d = new Date(d);
        const day = d.getDay(),
            diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
        return Math.floor(new Date(d.setDate(diff)).setHours(0, 0, 0) / 1000);
    }

    ngOnDestroy(): void {
        if (this._subscriptions) {
            this._subscriptions.unsubscribe();
        }
        this.progressBarService.needed.next(false);
    }

    refreshPage() {
        // clear data
        this.traceResponseArray = [];
        this.dataSource.data = [];
        this.groupedDataSource.data = [];
        this.availableDrivers = [];
        this.vehiclePositionAndDrivers = [];

        this.getDataForDrivers(this.companyId);
        this.searchDrivers(this.companyId);
    }

    // autoRefresh(newCompanyId) {
    //     this.updateSubscription = interval(50000).subscribe(
    //         (val) => {
    //             this.getDataForDrivers(newCompanyId);
    //             this.searchDrivers(newCompanyId);
    //     });
    // }

    getDataForDrivers(newCompanyId) {
        const subscription = this._driverService.getAllDrivers(newCompanyId).subscribe((response) => {
            this.availableDrivers = response;

            this.availableDrivers.sort(function (a, b) {
                const x = a.driver.driverFirstNames.toLowerCase();
                const y = b.driver.driverFirstNames.toLowerCase();
                if (x < y) {
                    return -1;
                }
                if (x > y) {
                    return 1;
                }
                return 0;
            });
        });
        this._subscriptions.add(subscription);
    }

    getDiagramDataForAPeriod(item, isVehicle = false) {
        this.diagrammLoaded = false;
        this.noDataText = false;
        const beforeOneWeek = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
        const day = beforeOneWeek.getDay();
        const diffToMonday = beforeOneWeek.getDate() - day + (day === 0 ? -6 : 1);
        const lastMonday = new Date(beforeOneWeek.setDate(diffToMonday));
        lastMonday.setUTCHours(0, 0, 0);

        this.periodStart = Math.trunc(lastMonday.getTime() / 1000);
        this.periodEnd = Math.trunc(new Date().getTime() / 1000);
        const period = { start: this.periodStart, end: this.periodEnd };
        const request = padDiagramPeriod(period);
        this.progressBarService.needed.next(true);

        const subscription = this._driverService
            .myGetActivitiesForAPeriod(
                item.driverInfo.driverId,
                request.start,
                request.end,
                localStorage.getItem('selectedCompanyId')
            )
            .subscribe(resp => {
                const days = Array.isArray(resp?.data) ? resp.data : [];
                const periodDays = filterDiagramDays(days, period);
                this.noDataText = !periodDays.some(dayItem => (dayItem.activities?.length ?? 0) > 0);

                this.chartTimezone = getCurrentTimezone() || Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
                const chartData = buildDriverChartData(
                    days as unknown as DriverDiagramDayLike[],
                    this.chartTimezone,
                    period,
                );
                const activities = periodDays.flatMap(dayItem => dayItem.activities ?? []);
                const dataEnd = this.lastActivityEnd(activities);
                const lastDownload = isVehicle && dataEnd
                    ? Math.min(dataEnd, item.uploadInformation.uploadTimeStamp || dataEnd)
                    : item.uploadInformation.uploadTimeStamp;

                this.addTraceOverlays(chartData, item, isVehicle, dataEnd, lastDownload);
                this.chartLocale = this._translate.currentLang || 'en-GB';
                const driverId = item.driverInfo.driverId;
                if (isVehicle) {
                    this.vehicleChartDataByDriverId = { ...this.vehicleChartDataByDriverId, [driverId]: chartData };
                } else {
                    this.chartDataByDriverId = { ...this.chartDataByDriverId, [driverId]: chartData };
                }

                this.diagrammLoaded = true;
                this.progressBarService.needed.next(false);
            }, () => {
                this.diagrammLoaded = true;
                this.progressBarService.needed.next(false);
            });
        this._subscriptions.add(subscription);
    }

    private addTraceOverlays(
        chartData: ActivityChartData,
        item: any,
        isVehicle: boolean,
        dataEnd: number | null,
        lastDownload: number | null,
    ): void {
        const highlights: ChartHighlight[] = [];
        const weeklyRest = item?.restLastWeekly1;
        if (weeklyRest && weeklyRest.end > weeklyRest.start) {
            highlights.push({
                start: weeklyRest.start,
                end: weeklyRest.end,
                color: 'rgba(252, 255, 197, 0.5)',
            });
        }
        const dailyRest = item?.restLastDaily;
        if (dailyRest && dailyRest.restEnd > dailyRest.restStart) {
            highlights.push({
                start: dailyRest.restStart,
                end: dailyRest.restEnd,
                color: 'rgba(252, 255, 197, 0.5)',
            });
        }

        const now = Math.floor(Date.now() / 1000);
        const noDataFrom = dataEnd ?? (lastDownload && lastDownload > 0 ? lastDownload : null);
        if (noDataFrom && noDataFrom < now) {
            highlights.push({
                start: noDataFrom,
                end: now,
                color: 'rgba(150, 150, 150, 0.25)',
                label: this._translate.instant('Download the driver card to see newer data'),
            });
        }
        chartData.highlights = highlights;

        const markers: ChartMarker[] = [];
        const weekStart = this.getMonday(new Date());
        if (weekStart > 0) {
            markers.push({
                time: weekStart,
                label: `${this._translate.instant('week')} #${moment(weekStart * 1000).week()}`,
                color: '#000000',
            });
        }
        if (lastDownload && lastDownload > 0) {
            markers.push({
                time: lastDownload,
                label: this._translate.instant('Last download'),
                color: '#000000',
            });
        }
        chartData.markers = markers;
    }

    private lastActivityEnd(activities: { day: number; endTime: number }[]): number | null {
        const ends = activities.map(a => a.day + a.endTime * 60).filter(end => !isNaN(end));
        return ends.length ? Math.max(...ends) : null;
    }

    formatDate(ts) {
        if (ts === 0 || ts === '' || moment(ts * 1000) >= moment([])) {
            return '---';
        } else {
            return moment.parseZone(ts * 1000).myFormat('LL');
        }
    }

    formatDateWithMonth(ts) {
        if (ts === 0 || ts === '') {
            return '---';
        } else {
            return moment.parseZone(ts * 1000).myFormat('LLL');
        }
    }

    formatFromNow(ts) {
        if (ts === '' || moment(ts * 1000) >= moment([])) {
            return '0';
        } else if (ts === 0) {
            // return this._translate.instant('processingFile');
            return '0';
        } else {
            moment.relativeTimeThreshold('h', 24);
            moment.relativeTimeThreshold('m', 60);
            return moment.parseZone(ts * 1000).fromNow();
        }
    }

    formatLastDownload(ts) {
        ts = 0;
        if (ts === 0 || ts === '' || moment(ts * 1000) >= moment([])) {
            return '0';
        } else {
            moment.relativeTimeThreshold('h', 24);
            moment.relativeTimeThreshold('m', 60);
            return moment.parseZone(ts * 1000).fromNow();
        }
    }

    getHoursFromADate(ts, name) {
        if (ts === 0 || ts === '') {
            return '--:--';
        } else {
            const currentDay = new Date().getTime();
            const duration = currentDay - (ts * 1000);
            return Math.floor(duration / 3600000);
        }
    }

    searchDrivers(newCompanyId) {
        this.progressBarService.needed.next(true);
        this.queryRunning = true;
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        const proSubscription = this.proService.pro$.subscribe(pro => {
            const userIsPro = this._authService.getLoggedInUser().proUser;
            const isReseller = this._authService.getLoggedInUser().clientIsReseller;
            const hasLiveDataAccess = pro.pro !== 'NOT_PRO' || (userIsPro && isReseller);

            // Terminal data (readTachographParameters) feeds the Map and the Vehicles tab. It is independent of
            // the drivers trace below, so it is requested first and handled on its own: it renders as soon as it
            // arrives and never waits for the (slower) trace query to finish.
            if (this.featureEnabled || this.vehiclesTabEnabled) {
                const tachographParametersSubscription = this.driverstraceService
                    .getDriversTrace2(newCompanyId, timezone)
                    .subscribe({
                        next: resp => {
                            this.progressBarService.needed.next(false);
                            if (hasLiveDataAccess) {
                                resp.result.sort((a, b) => (a.calculatedValues.baseTime < b.calculatedValues.baseTime) ? 1 : -1);
                                this.vehiclePositionAndDrivers = resp.vehiclePositionAndDrivers;
                                this.allowBanner = false;
                                this.dataexistsFunction();
                                this.driversGroupedByVehicle(resp.result);
                            } else {
                                this.dataexistsFunction();
                                this.driversGroupedByVehicle(this.dummyData);
                                this.allowBanner = true;
                            }
                        },
                        error: error => {
                            console.error('Error fetching tachograph parameters:', error);
                            this.progressBarService.needed.next(false);
                        }
                    });
                this._subscriptions.add(tachographParametersSubscription);
            }

            // The drivers trace is independent of the terminal data above: both queries run in parallel.
            const driverTraceSubscription = this.driverstraceService
                .getDriversTrace(newCompanyId, timezone)
                .subscribe({
                    next: resp => {
                        this.progressBarService.needed.next(false);
                        this.queryRunning = false;
                        if (hasLiveDataAccess) {
                            resp.result.sort((a, b) => (a.calculatedValues.baseTime < b.calculatedValues.baseTime) ? 1 : -1);
                            this.traceResponseArray = resp.result;
                            this.dataSource.data = this.traceResponseArray;
                            this.allowBanner = false;
                            this.dataexistsFunction();
                        } else {
                            this.traceResponseArray = this.dummyData;
                            this.dataSource.data = this.traceResponseArray;
                            this.dataexistsFunction();
                            this.allowBanner = true;
                        }
                    },
                    error: error => {
                        console.error('Error fetching driver trace data:', error);
                        this.progressBarService.needed.next(false);
                        this.queryRunning = false;
                    }
                });
            this._subscriptions.add(driverTraceSubscription);
        });
        this.companySpecificSubscription.add(proSubscription);
    }

    counter(i: number) {
        if (i < 0) {
            return new Array(0);
        } else {
            return new Array(i);
        }
    }

    sortByStatus() {
        if (this.sortByStatusFlag) {
            this.traceResponseArray = this.traceResponseArray.sort((a, b) => (a.calculatedValues.baseTime < b.calculatedValues.baseTime) ? 1 : -1);
            this.sortByStatusFlag = !this.sortByStatusFlag;
        } else {
            this.traceResponseArray = this.traceResponseArray.sort((a, b) => (a.calculatedValues.baseTime > b.calculatedValues.baseTime) ? 1 : -1);
            this.sortByStatusFlag = !this.sortByStatusFlag;
        }

        this.dataSource.data = this.traceResponseArray;
        // this.driversGroupedByVehicle();
    }

    sortByDriverName() {
        if (this.sortByDriverFlag) {
            this.traceResponseArray = this.traceResponseArray.sort((a, b) => (a.driverInfo.name > b.driverInfo.name) ? 1 : -1);
            this.sortByDriverFlag = !this.sortByDriverFlag;
        } else {
            this.traceResponseArray = this.traceResponseArray.sort((a, b) => (a.driverInfo.name < b.driverInfo.name) ? 1 : -1);
            this.sortByDriverFlag = !this.sortByDriverFlag;
        }
        this.dataSource.data = this.traceResponseArray;
        // this.driversGroupedByVehicle();
    }

    checkIfSameDate(dateTime) {
        if (this.formatDateWithoutYear(dateTime) === this.now) {
            return true;
        } else {
            return false;
        }
    }

    makeDataForDrivers() {
        for (let i = 0; i < this.availableDrivers.length; i++) {
            this.driversNames.push(this.nameFormatService.formatName(this.availableDrivers[i].driver.driverFirstNames, this.availableDrivers[i].driver.driverSurnames));
            this.driversCardNumber.push(this.availableDrivers[i].driver.cardNumber);
        }
    }

    dataexistsFunction() {
        this.dataexists = true;
    }

    sortLoadFunction() {
        this.sortload = true;
    }

    szemafor(ts) {
        if (ts > moment([]).unix()) {
            return 'piros';
        } else {
            return 'zold';
        }
    }

    nowFormatDateWithoutYear(ts) {
        if (ts === 0 || ts === '') {
            return '--/--/---- --:--';
        } else {
            this.dateChange = moment(ts).myFormat('dddd HH:mm');
            return moment(ts).myFormat('dddd HH:mm');
        }
    }

    formatDateWithoutYear(ts) {
        if (ts === 0 || ts === '') {
            return '--/--/---- --:--';
        } else {
            return moment(ts * 1000).myFormat('dddd HH:mm');
        }
    }

    formatDateWithoutDay(ts) {
        if (ts === 0 || ts === '') {
            return '--/--/---- --:--';
        } else {
            return moment(ts * 1000).myFormat('MMM Do HH:mm');
        }
    }

    /**
     * Minutes until the next break: as reported by the terminal (nextBreak / nextBreakField), otherwise the
     * driving time left until the continuous (4:30) or the daily limit is reached, whichever comes first.
     */
    nextBreak(calculatedValue): { inMin: number; from: 'continuous' | 'daily' | null } | null {
        if (calculatedValue?.nextBreak != null) {
            const field = (calculatedValue.nextBreakField || '').toLowerCase();
            const from = field.includes('continuous') ? 'continuous' : field.includes('daily') ? 'daily' : null;
            return { inMin: calculatedValue.nextBreak, from };
        }
        const continuous = calculatedValue?.drivingContinuousRemaining;
        const daily = calculatedValue?.drivingDailyRemaining;
        if (continuous == null && daily == null) {
            return null;
        }
        if (daily == null || (continuous != null && continuous <= daily)) {
            return { inMin: continuous, from: 'continuous' };
        }
        return { inMin: daily, from: 'daily' };
    }

    /** 9h while reduced daily rests are still available this week, otherwise 11h. */
    nextDailyRestHours(calculatedValue): 9 | 11 {
        return calculatedValue.lessThan11hBreakTimesFromLastWeeklyBreak < calculatedValue.lessThan11hBreakTimesFromLastWeeklyBreakMax ? 9 : 11;
    }

    /** True when an epoch-seconds timestamp is not in the future. */
    isPast(ts: number): boolean {
        return ts * 1000 <= Date.now();
    }

    checkDailyDriving(calculatedValue) {
        let drivingDailyMax = [];
        let maxValue: number;
        drivingDailyMax = calculatedValue.drivingDailyMAX.split(',').map(x => parseInt(x, 10));
        if (calculatedValue.moreThan9hDrivingTimesFromLastWeeklyBreakMax - calculatedValue.moreThan9hDrivingTimesFromLastWeeklyBreak === 0) {
            maxValue = Math.min(...drivingDailyMax);
        } else {
            maxValue = Math.max(...drivingDailyMax);
        }
        return maxValue;
    }

    formatTime(ts) {
        if (ts < 0) {
            return '- -:- -';
        }
        if (ts == 0 || ts === '') {
            return '00:00';
        }

        switch (ts) {
            case 0:
            case '':
                return '00:00';
            default:
                const hour = Math.floor(ts / 60);
                const minute = ts % 60;

                const hourf = hour < 10 ? '0' + hour : hour;
                const minutef = minute < 10 ? '0' + minute : minute;

                return hourf + ':' + minutef;
        }
    }

    formatDuration(ts) {
        if (ts === 0 || ts === '') {
            return '--:--';
        } else {
            let hour, minute;
            minute = Math.floor(ts / 60);
            hour = Math.floor(minute / 60);
            minute = minute % 60;

            if (minute < 10) {
                return hour + ':0' + minute;
            } else {
                return hour + ':' + minute;
            }
        }
    }

    getDailyHours(ts, number, number2?) {
        let hour, minute;
        minute = Math.floor(ts / 60);
        hour = Math.floor(minute / 60);

        if (number2 === undefined) {
            return hour < number;
        } else {
            return hour >= number && hour < number2;
        }
    }

    getHoursFromDate(ts) {
        let hour, minute;
        minute = Math.floor(ts / 60);
        hour = Math.floor(minute / 60);
        return hour;
    }

    sortTable(n) {
        this.sortload = false;
        let table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
        table = document.getElementById('coolTable');
        switching = true;
        // Set the sorting direction to ascending:
        dir = 'asc';
        /* Make a loop that will continue until
        no switching has been done: */
        while (switching) {
            // Start by saying: no switching is done:
            switching = false;
            rows = table.rows;
            /* Loop through all table rows (except the
            first, which contains table headers): */
            for (i = 1; i < (rows.length - 1); i++) {
                // Start by saying there should be no switching:
                shouldSwitch = false;
                /* Get the two elements you want to compare,
                one from current row and one from the next: */
                x = rows[i].getElementsByTagName('TD')[n];
                y = rows[i + 1].getElementsByTagName('TD')[n];
                /* Check if the two rows should switch place,
                based on the direction, asc or desc: */
                if (dir === 'asc') {
                    if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
                        // If so, mark as a switch and break the loop:
                        shouldSwitch = true;
                        this.sortLoadFunction();
                        break;
                    }
                } else if (dir === 'desc') {
                    if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
                        // If so, mark as a switch and break the loop:
                        shouldSwitch = true;
                        this.sortLoadFunction();
                        break;
                    }
                }
            }
            if (shouldSwitch) {
                /* If a switch has been marked, make the switch
                and mark that a switch has been done: */
                rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
                switching = true;
                this.sortLoadFunction();
                // Each time a switch is done, increase this count by 1:
                switchcount++;
            } else {
                /* If no switching has been done AND the direction is "asc",
                set the direction to "desc" and run the while loop again. */
                if (switchcount === 0 && dir === 'asc') {
                    dir = 'desc';
                    switching = true;
                    this.sortLoadFunction();
                }
            }
        }
    }

    myPrint(): void {
        const printContents = document.getElementById('forprint').innerHTML;
        const popupWin = window.open();
        popupWin.document.open();
        popupWin.document.write('<html lang="">' +
            '<head>' +
            '<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">' +
            '<title></title></head>' +
            '</head><style>' +
            'table {\n' +
            '    border-collapse: collapse;\n' +
            '    border-spacing: 0;\n' +
            '    width: 100%;\n' +
            '    border: 1px solid #ddd;\n' +
            '}\n' +
            '\n' +
            'th, td {\n' +
            '    text-align: left;\n' +
            '    padding: 3px;\n' +
            '}\n' +
            '\n' +
            'tr:nth-child(even) {\n' +
            '    background-color: #f2f2f2\n' +
            '}' +
            '</style><body onload="window.print()">' +
            printContents +
            '</html>');
        popupWin.document.close();
    }

    searchFunction() {
        let filteredArray = [];
        filteredArray = this.traceResponseArray.filter(item =>
        (item.driverInfo.name.toLowerCase().includes(this.filterValue.toLowerCase()) ||
            item.driverInfo.cardNumber.includes(this.filterValue)));
        this.dataSource.data = filteredArray;
    }

    nowT = new Date().getTime() / 1000;
    dummyData: Result[] = [
        {
            "driverInfo": {
                "cardNumber": "CARD0000000001",
                "driverId": null,
                "name": "Test Driver 1",
            },
            "lastActivity": {
                "activity": "DRIVING",
                "activityLength": 0,
                "startTime": this.nowT,
            },
            "previousActivity": {
                "activity": "WORK",
                "activityLength": 5,
                "startTime": this.nowT - 5,
            },
            "restLastDaily": {
                "restStart": this.nowT - 5 * 60 * 60,
                "restEnd": this.nowT - 5 * 60 * 60 + 677,
                "restLength": 677,
            },
            "lastActivityDay": {
                "drivingCurrentDay": 50,
                "crew": false,
                "dayStart": this.nowT,
                "dayEnd": this.nowT,
            },
            "restLastWeekly1": {
                "start": this.nowT - 24 * 60 * 60,
                "end": this.nowT - 24 * 60 * 60 + 2448,
                "length": 2448,
            },
            "drivingLast2Weeks": 2516,
            "calculatedValues": {
                "workTimes": {
                    "workTimeWeekly": 1034,
                    "workTimeWeeklyMax": 3600,
                    "workTimeAverageLast16Weeks": 1332,
                    "nightWorkPerformedThisDay": false,
                    "maxWorkWhenNightWorkPerformed": 900,
                    "workContinuousWithoutBreak": 56,
                    "workContinuousWithoutBreakMax": 360,
                    "totalWorkToday": 56,
                    "justWorkForToday": 56
                },
                "baseTime": this.nowT,
                "drivingTwoWeeklyRemaining": 2884,
                "drivingTwoWeeklyMax": 5400,
                "projections": {
                    "nextWorkStart": this.nowT,
                    "nextWorkLength": 600,
                    "nextWorkComments": [],
                    "nextWorkCommentsTrans": []
                },
                "drivingContinuousRemaining": 220,
                "drivingContinuousMax": 270,
                "drivingDailyRemaining": 550,
                "drivingDailyRemainingCurrentDay": 550,
                "drivingDailyMAX": "540,600",
                "drivingWeeklyRemaining": 2546,
                "drivingWeeklyMax": 3360,
                "nextDailyBreakStart": this.nowT,
                "nextDailyBreakStartAsCrew": this.nowT,
                "nextWeeklyBreakStart": this.nowT,
                "moreThan9hDrivingTimesFromLastWeeklyBreak": 0,
                "moreThan9hDrivingTimesFromLastWeeklyBreakMax": 2,
                "lessThan11hBreakTimesFromLastWeeklyBreak": 1,
                "lessThan11hBreakTimesFromLastWeeklyBreakMax": 3
            },
            "uploadInformation": {
                "uploadTimeStamp": this.nowT - 25 * 60,
                "minutesSinceUpload": 25,
                "minutesBetweenLastActivityAndUpload": 4,
                "minutesSinceLastActivity": 45
            }
        }
    ] as unknown as Result[];
}
